var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from 'styled-components';
import { breakpoints, colors } from '../../../abstracts';
import { Text } from '../../Text';
var getCustomDashBorder = function (color) {
    var stroke = color.split('#')[1].toLocaleUpperCase();
    var url = "\"data:image/svg+xml,%3Csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg' %3E%3Crect width='100%25' height='100%25' fill='none' rx='7.5' stroke='%23".concat(stroke, "' stroke-width='1.5' stroke-linecap='round' stroke-dasharray='3 5'/%3E%3C/svg%3E\"");
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background-repeat: no-repeat;\n    border-radius: 0.5rem;\n    background-color: transparent;\n    border-style: none;\n    background-image: url(", ");\n  "], ["\n    background-repeat: no-repeat;\n    border-radius: 0.5rem;\n    background-color: transparent;\n    border-style: none;\n    background-image: url(", ");\n  "])), url);
};
var getButtonBackgroundColor = function (_a) {
    var disabled = _a.disabled, hoverState = _a.hoverState;
    if (disabled) {
        return colors.disabledBackground;
    }
    else if (hoverState === 'active') {
        return colors.neutralBrighter;
    }
    else {
        return '#ffffff';
    }
};
var getBorderStyle = function (_a) {
    var disabled = _a.disabled, isLoading = _a.isLoading, hoverState = _a.hoverState;
    if (disabled) {
        return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      border: 0.0625rem solid ", ";\n    "], ["\n      border: 0.0625rem solid ", ";\n    "])), colors.neutralDeep);
    }
    else if (isLoading || hoverState === 'hover') {
        return getCustomDashBorder(colors.black);
    }
    else if (hoverState === 'active') {
        return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      border: 0.0625rem solid ", ";\n    "], ["\n      border: 0.0625rem solid ", ";\n    "])), colors.black);
    }
    else {
        return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      ", "\n    "], ["\n      ", "\n    "])), getCustomDashBorder(colors.neutralDeep));
    }
};
export var FileUploaderButton = styled.button(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  background-repeat: no-repeat;\n  border-radius: 0.5rem;\n  position: relative;\n  margin-bottom: 0.75rem;\n\n  ", ";\n  background-color: ", ";\n\n  ", ";\n  width: 20rem;\n  height: 6.688rem;\n  ", " {\n    width: calc(100vw - 2rem);\n  }\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"], ["\n  background-repeat: no-repeat;\n  border-radius: 0.5rem;\n  position: relative;\n  margin-bottom: 0.75rem;\n\n  ", ";\n  background-color: ", ";\n\n  ", ";\n  width: 20rem;\n  height: 6.688rem;\n  ", " {\n    width: calc(100vw - 2rem);\n  }\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"])), getBorderStyle, getButtonBackgroundColor, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? "cursor: not-allowed" : "cursor: pointer;");
}, breakpoints.xs);
export var StyledText = styled(Text)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  margin-top: ", "\n  margin-bottom: 0;\n\n  background-color: ", ";\n"], ["\n  margin-top: ", "\n  margin-bottom: 0;\n\n  background-color: ", ";\n"])), function (_a) {
    var isLoading = _a.isLoading;
    return (isLoading ? "0.5rem;" : "0.25rem;");
}, getButtonBackgroundColor);
var getIconSvgPathFillColor = function (_a) {
    var disabled = _a.disabled, hoverState = _a.hoverState, isPrimaryAction = _a.isPrimaryAction, theme = _a.theme;
    if (disabled)
        return colors.neutralDeep;
    else if (isPrimaryAction)
        return colors.white;
    else if (hoverState == 'hover')
        return theme.primaryHover;
    else if (hoverState == 'active')
        return theme.primaryPressed;
    else
        return isPrimaryAction ? colors.white : theme.primary;
};
var getIconBorderColor = function (_a) {
    var disabled = _a.disabled, hoverState = _a.hoverState, theme = _a.theme;
    if (disabled)
        return colors.neutralDeep;
    else if (hoverState == 'hover')
        return theme.primaryHover;
    else if (hoverState == 'active')
        return theme.primaryPressed;
    else
        return theme.primary;
};
var getIconBackgroundColor = function (_a) {
    var disabled = _a.disabled, hoverState = _a.hoverState, isPrimaryAction = _a.isPrimaryAction, theme = _a.theme;
    if (disabled)
        return colors.disabledBackground;
    else if (hoverState == 'hover')
        return isPrimaryAction ? theme.primaryHover : colors.neutralBrightest;
    else if (hoverState == 'active')
        return isPrimaryAction ? theme.primaryPressed : colors.disabledBackground;
    else
        return isPrimaryAction ? theme.primary : 'transparent';
};
export var FileUploadButtonIconBorder = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  svg path {\n    fill: ", ";\n  }\n  border-color: ", ";\n  background: ", ";\n  border-radius: 10rem;\n  height: 2rem;\n  width: 2rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-style: solid;\n  border-width: 0.125rem;\n"], ["\n  svg path {\n    fill: ", ";\n  }\n  border-color: ", ";\n  background: ", ";\n  border-radius: 10rem;\n  height: 2rem;\n  width: 2rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-style: solid;\n  border-width: 0.125rem;\n"])), getIconSvgPathFillColor, getIconBorderColor, getIconBackgroundColor);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
